// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TimeCounter_wrapper__ahhnA","time-counter":"TimeCounter_time-counter__u5ZhB","time-label":"TimeCounter_time-label__GwlA0"};